import { Rule } from "../../data-access/models/rule.model";
import { RulesEnum } from "../../enums/rulesEnum";

export function evaluateRules(data: any, rules: Rule[]): boolean {
  const getValue = (obj: any, path: string) =>
    path.split('.').reduce((currentObj, key) => currentObj[key], obj);

  return rules.every(rule => {
    const value = getValue(data, rule.property);

    switch (rule.operator) {
      case RulesEnum.EQUALS:
        return value === rule.value;
      case RulesEnum.NOT_EQUALS:
        return value !== rule.value;
      case RulesEnum.TRUTHY:
        return !!value;
      case RulesEnum.ARRAY_NOT_EMPTY:
        return Array.isArray(value) && value.length > 0;
      default:
        return false;
    }
  });
}
